import { GOOGLE, FACEBOOK, LINKEDIN, APPLE } from '../../../constants/Copy';

const providers = {
	googleplus: GOOGLE,
	apple: APPLE,
	facebook: FACEBOOK,
	linkedin: LINKEDIN,
};

export default (provider) => {
	if (provider && providers[provider.toLowerCase()]) {
		return providers[provider.toLowerCase()];
	}
	return provider;
};
